// extracted by mini-css-extract-plugin
export default {"sidebarContainer":"sidebar_sidebarContainer__jys+V"};